export default __webpack_public_path__ + "static/media/contact.1123931e.png";